import { render, staticRenderFns } from "./CommandAuth.vue?vue&type=template&id=8c60e7da&scoped=true"
import script from "./CommandAuth.vue?vue&type=script&lang=js"
export * from "./CommandAuth.vue?vue&type=script&lang=js"
import style0 from "./CommandAuth.vue?vue&type=style&index=0&id=8c60e7da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c60e7da",
  null
  
)

export default component.exports